import React from 'react';
import { Helmet } from 'react-helmet-async';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export interface TitleProps {
  overwrite?: boolean;
  title?: string;
}

const Title = ({ overwrite, title }: TitleProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  // eslint-disable-next-line no-irregular-whitespace
  const prefixed = `${title ?? t('meta.default')} | ${t('meta.base')}`;
  const actual = overwrite ? title : prefixed;

  return (
    <Helmet>
      <title>{actual}</title>
      <meta content={actual} property="og:title" />
      <meta content={t('homeOwnerDescription')} name="description" />
      <meta content={t('homeOwnerDescription')} property="og:description" />
      <meta content="website" property="og:type" />
      <meta content="https://hover.to" property="og:url" />

      {/*
        the only well working solution for sharing is an image
        with fixed url and specific params (RGB, 8 bit, 320x320px)
        if we can find another working approach I’d be happy not to use the assets,
        but at this point we don’t have a better solution
      */}
      <meta
        content="https://assets.hover.to/homeowner/favicon-320x320.png"
        property="og:image"
      />
    </Helmet>
  );
};

export { Title };
